(() => {
  'use strict';

  if (window.__awayBudgetSimulatorV13Booted) {
    window.__awayBudgetSimulatorV13InitWithin?.(document);
    return;
  }

  window.__awayBudgetSimulatorV13Booted = true;

  const ROOT_SELECTOR = '.away-simulator[data-data-url]';
  const AVG_WEEKS_PER_MONTH = 4.34524;
  const CONFIG_CACHE = new Map();
  const FX_CACHE = new Map();

  const COMPONENT_LABELS = {
    food_core: 'Temel gıda',
    transport_commute: 'Ulaşım',
    mobile_share: 'Mobil hat / veri',
    hygiene_share: 'Hijyen / kişisel bakım',
    laundry_share: 'Çamaşır',
    household_share: 'Ev içi temel sarf',
    study_share: 'Ders materyali / baskı',
    housing_share: 'Konaklama'
  };

  const CURRENCY_NAMES = {
    TRY: 'Türk lirası',
    EUR: 'Euro',
    GBP: 'İngiliz sterlini',
    USD: 'ABD doları',
    CAD: 'Kanada doları',
    AUD: 'Avustralya doları'
  };

  const WORK_META = {
    available: {
      tone: 'success',
      label: 'Genel koşullarda mümkün',
      cardClass: 'card-work--available'
    },
    restricted: {
      tone: 'warning',
      label: 'Koşullu / sınırlı',
      cardClass: 'card-work--restricted'
    },
    route_dependent: {
      tone: 'info',
      label: 'Rota doğrulaması gerekli',
      cardClass: 'card-work--route-dependent'
    },
    unavailable: {
      tone: 'muted',
      label: 'Gelir varsayımı kapalı',
      cardClass: 'card-work--unavailable'
    }
  };

  function toNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function daysSince(value) {
    if (!value) return Number.POSITIVE_INFINITY;
    const date = new Date(`${value}T12:00:00Z`);
    if (Number.isNaN(date.getTime())) return Number.POSITIVE_INFINITY;
    return Math.floor((Date.now() - date.getTime()) / 86400000);
  }

  function latestDate(values) {
    const valid = (values || [])
      .filter(Boolean)
      .map((value) => new Date(`${value}T12:00:00Z`))
      .filter((date) => !Number.isNaN(date.getTime()))
      .sort((a, b) => a.getTime() - b.getTime());

    return valid.length ? valid[valid.length - 1].toISOString().slice(0, 10) : null;
  }

  function formatDateTR(value) {
    if (!value) return '—';

    try {
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }).format(new Date(`${value}T12:00:00Z`));
    } catch {
      return value;
    }
  }

  function formatCurrency(amount, currency, maximumFractionDigits = 0) {
    if (!Number.isFinite(amount)) return '—';

    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency,
        maximumFractionDigits
      }).format(amount);
    } catch {
      return `${amount.toFixed(maximumFractionDigits)} ${currency}`;
    }
  }

  function formatNumber(amount, digits = 2) {
  if (!Number.isFinite(amount)) return '—';

  const safeDigits = Math.min(
    Math.max(Number.isInteger(digits) ? digits : 2, 0),
    6
  );

  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: safeDigits,
    maximumFractionDigits: safeDigits
  }).format(amount);
}

  function parseCsvLine(line) {
    const cells = [];
    let current = '';
    let quoted = false;

    for (let index = 0; index < line.length; index += 1) {
      const char = line[index];

      if (char === '"') {
        if (quoted && line[index + 1] === '"') {
          current += '"';
          index += 1;
        } else {
          quoted = !quoted;
        }
      } else if (char === ',' && !quoted) {
        cells.push(current);
        current = '';
      } else {
        current += char;
      }
    }

    cells.push(current);
    return cells;
  }

  function parseEcbCsv(text) {
    const lines = String(text || '').trim().split(/\r?\n/).filter(Boolean);
    if (lines.length < 2) throw new Error('ECB CSV yanıtı boş.');

    const headers = parseCsvLine(lines[0]).map((item) => item.trim());
    const currencyIndex = headers.indexOf('CURRENCY');
    const dateIndex = headers.indexOf('TIME_PERIOD');
    const valueIndex = headers.indexOf('OBS_VALUE');

    if (currencyIndex < 0 || dateIndex < 0 || valueIndex < 0) {
      throw new Error('ECB CSV sütunları beklenen yapıda değil.');
    }

    const rates = { EUR: 1 };
    let rateDate = null;

    lines.slice(1).forEach((line) => {
      const row = parseCsvLine(line);
      const currency = row[currencyIndex];
      const value = Number(row[valueIndex]);
      const date = row[dateIndex];

      if (currency && Number.isFinite(value) && value > 0) {
        rates[currency] = value;
        if (!rateDate || date > rateDate) rateDate = date;
      }
    });

    if (!rates.TRY) throw new Error('ECB CSV içinde TRY kuru bulunamadı.');
    return { rates, rateDate };
  }

  function parseEcbXml(text) {
    const documentNode = new DOMParser().parseFromString(text, 'application/xml');
    if (documentNode.querySelector('parsererror')) {
      throw new Error('ECB XML yanıtı ayrıştırılamadı.');
    }

    const datedCube = documentNode.querySelector('Cube[time]');
    if (!datedCube) throw new Error('ECB XML tarih düğümü bulunamadı.');

    const rates = { EUR: 1 };
    datedCube.querySelectorAll('Cube[currency][rate]').forEach((node) => {
      const currency = node.getAttribute('currency');
      const rate = Number(node.getAttribute('rate'));
      if (currency && Number.isFinite(rate) && rate > 0) {
        rates[currency] = rate;
      }
    });

    if (!rates.TRY) throw new Error('ECB XML içinde TRY kuru bulunamadı.');
    return { rates, rateDate: datedCube.getAttribute('time') };
  }

  async function fetchText(url, timeoutMs = 6500) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-store',
        credentials: 'omit',
        signal: controller.signal,
        headers: { Accept: 'text/csv, application/xml, text/xml, */*' }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.text();
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function loadConfig(root) {
    const dataUrl = root.getAttribute('data-data-url');
    if (!dataUrl) return null;

    if (!CONFIG_CACHE.has(dataUrl)) {
      CONFIG_CACHE.set(
        dataUrl,
        fetch(dataUrl, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store'
        })
          .then((response) => {
            if (!response.ok) throw new Error(`JSON HTTP ${response.status}`);
            return response.json();
          })
          .catch((error) => {
            console.error('[AwaySimulator] JSON yükleme hatası:', error);
            return null;
          })
      );
    }

    return CONFIG_CACHE.get(dataUrl);
  }

  function fallbackFx(config) {
    const rates = { EUR: 1 };
    (config?.fx_config?.rates || []).forEach((item) => {
      if (item.target_currency && toNumber(item.rate) > 0) {
        rates[item.target_currency] = toNumber(item.rate);
      }
    });

    return {
      rates,
      rateDate: config?.fx_config?.rates_last_checked || null,
      mode: 'fallback',
      sourceName: 'Tarihli JSON yedek kuru'
    };
  }

  async function loadFx(config, force = false) {
    const cacheKey = config?.fx_config?.live_source?.api_url || 'away-fx';
    if (force) FX_CACHE.delete(cacheKey);
    if (FX_CACHE.has(cacheKey)) return FX_CACHE.get(cacheKey);

    const promise = (async () => {
      const timeoutMs = toNumber(config?.fx_config?.live_source?.timeout_ms) || 6500;
      const apiUrl = config?.fx_config?.live_source?.api_url;
      const xmlUrl = config?.fx_config?.live_source?.daily_url;

      if (apiUrl) {
        try {
          const parsed = parseEcbCsv(await fetchText(apiUrl, timeoutMs));
          return {
            ...parsed,
            mode: 'live',
            sourceName: 'ECB Data Portal'
          };
        } catch (error) {
          console.warn('[AwaySimulator] ECB Data API kullanılamadı:', error);
        }
      }

      if (xmlUrl) {
        try {
          const parsed = parseEcbXml(await fetchText(xmlUrl, timeoutMs));
          return {
            ...parsed,
            mode: 'live',
            sourceName: 'ECB günlük referans kurları'
          };
        } catch (error) {
          console.warn('[AwaySimulator] ECB XML kullanılamadı:', error);
        }
      }

      return fallbackFx(config);
    })();

    FX_CACHE.set(cacheKey, promise);
    return promise;
  }

  const SimulatorData = {
    countries(config) {
      return (config?.supported_countries || []).filter(
        (item) => item.enabled_in_selector && item.launch_enabled
      );
    },

    programs(config) {
      return (config?.supported_program_types || []).filter((item) => item.enabled);
    },

    country(config, code) {
      return (config?.supported_countries || []).find(
        (item) => item.country_code === code
      ) || null;
    },

    basket(config, countryCode, regionCode) {
      return (config?.basket_catalog || []).find((item) => (
        item.country_code === countryCode &&
        (item.region_code || null) === (regionCode || null) &&
        item.launch_enabled
      )) || null;
    },

    housing(config, countryCode, regionCode, housingType) {
      return (config?.housing_catalog || []).find((item) => (
        item.country_code === countryCode &&
        (item.region_code || null) === (regionCode || null) &&
        item.housing_type === housingType &&
        item.launch_enabled
      )) || null;
    },

    rule(config, countryCode, programType, regionCode) {
      return (config?.country_rules || []).find((item) => (
        item.country_code === countryCode &&
        item.program_type === programType &&
        (item.region_code || null) === (regionCode || null)
      )) || null;
    },

    rate(ctx, currency) {
      if (currency === 'EUR') return 1;
      return toNumber(ctx.fx?.rates?.[currency]) || 0;
    },

    convert(ctx, amount, fromCurrency, toCurrency) {
      if (!Number.isFinite(amount)) return Number.NaN;
      if (fromCurrency === toCurrency) return amount;

      const fromRate = this.rate(ctx, fromCurrency);
      const toRate = this.rate(ctx, toCurrency);
      if (!fromRate || !toRate) return Number.NaN;

      return (amount / fromRate) * toRate;
    }
  };

  function createContext(root, config, fxData) {
    const form = root.querySelector('[data-role="simulator-form"]');

    return {
      root,
      config,
      fx: fxData,
      form,
      defaults: {
        country: root.getAttribute('data-default-country') || '',
        program: root.getAttribute('data-default-program') || ''
      },
      fields: {
        budget: form?.querySelector('[data-field="budget"]'),
        currency: form?.querySelector('[data-field="currency"]'),
        country: form?.querySelector('[data-field="country"]'),
        program: form?.querySelector('[data-field="program"]'),
        region: form?.querySelector('[data-field="region"]'),
        housingEnabled: form?.querySelector('[data-field="housing_enabled"]'),
        housingType: form?.querySelector('[data-field="housing_type"]'),
        submit: form?.querySelector('[data-field="submit"]')
      },
      wrappers: {
        budget: form?.querySelector('[data-field-wrapper="budget"]'),
        country: form?.querySelector('[data-field-wrapper="country"]'),
        program: form?.querySelector('[data-field-wrapper="program"]'),
        region: form?.querySelector('[data-field-wrapper="region"]')
      },
      regionRow: form?.querySelector('[data-role="region-row"]'),
      formErrors: form?.querySelector('[data-role="form-errors"]'),
      fxNodes: {
        panel: root.querySelector('[data-role="fx-panel"]'),
        status: root.querySelector('[data-role="fx-status"]'),
        date: root.querySelector('[data-role="fx-date"]'),
        pairLabel: root.querySelector('[data-role="fx-pair-label"]'),
        pairValue: root.querySelector('[data-role="fx-pair-value"]'),
        budgetConversion: root.querySelector('[data-role="fx-budget-conversion"]'),
        rates: root.querySelector('[data-role="fx-rates"]'),
        sourceName: root.querySelector('[data-role="fx-source-name"]'),
        sourceNote: root.querySelector('[data-role="fx-source-note"]'),
        sourceLink: root.querySelector('[data-role="fx-source-link"]'),
        refresh: root.querySelector('[data-role="fx-refresh"]')
      },
      results: {
        statusBlock: root.querySelector('[data-role="status-block"]'),
        statusTitle: root.querySelector('[data-role="status-title"]'),
        statusText: root.querySelector('[data-role="status-text"]'),
        verifiedDateLabel: root.querySelector('[data-role="verified-date-label"]'),
        fxDateLabel: root.querySelector('[data-role="fx-date-label"]'),
        routeSummary: root.querySelector('[data-role="route-summary"]'),
        marketCard: root.querySelector('[data-role="market-card"]'),
        marketIntro: root.querySelector('[data-role="market-intro"]'),
        marketValue: root.querySelector('[data-role="market-value"]'),
        marketCurrency: root.querySelector('[data-role="market-currency"]'),
        marketSubvalue: root.querySelector('[data-role="market-subvalue"]'),
        livingBreakdown: root.querySelector('[data-role="living-breakdown"]'),
        basketNote: root.querySelector('[data-role="basket-note"]'),
        housingNote: root.querySelector('[data-role="housing-note"]'),
        coverageNote: root.querySelector('[data-role="coverage-note"]'),
        marketSourceNote: root.querySelector('[data-role="market-source-note"]'),
        coverageLabel: root.querySelector('[data-role="coverage-label"]'),
        coverageMeter: root.querySelector('[data-role="coverage-meter"]'),
        coverageFill: root.querySelector('[data-role="coverage-fill"]'),
        marketStaleWarning: root.querySelector('[data-role="market-stale-warning"]'),
        workCard: root.querySelector('[data-role="work-card"]'),
        workBadge: root.querySelector('[data-role="work-badge"]'),
        workText: root.querySelector('[data-role="work-text"]'),
        workMeta: root.querySelector('[data-role="work-meta"]'),
        workDate: root.querySelector('[data-role="work-date"]'),
        workSourceLink: root.querySelector('[data-role="work-source-link"]'),
        workStaleWarning: root.querySelector('[data-role="work-stale-warning"]'),
        incomeCard: root.querySelector('[data-role="income-card"]'),
        incomeBadge: root.querySelector('[data-role="income-badge"]'),
        incomeValue: root.querySelector('[data-role="income-value"]'),
        incomeCurrency: root.querySelector('[data-role="income-currency"]'),
        incomeText: root.querySelector('[data-role="income-text"]'),
        incomeMeta: root.querySelector('[data-role="income-meta"]')
      },
      links: {
        list: root.querySelector('[data-role="links-list"]'),
        empty: root.querySelector('[data-role="links-empty"]')
      },
      globalDate: root.querySelector('[data-role="global-date"]'),
      globalFxDate: root.querySelector('[data-role="global-fx-date"]'),
      globalFxStatus: root.querySelector('[data-role="global-fx-status"]'),
      secondaryCta: root.querySelector('[data-role="secondary-cta"]')
    };
  }

  function populateSelect(select, items, placeholder, valueKey, textKey) {
    if (!select) return;

    select.innerHTML = '';
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.disabled = true;
    placeholderOption.selected = true;
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    (items || []).forEach((item) => {
      const option = document.createElement('option');
      option.value = item[valueKey];
      option.textContent = item[textKey];
      select.appendChild(option);
    });
  }

  function setFieldError(ctx, name, message = '') {
    const wrapper = ctx.wrappers[name];
    if (!wrapper) return;
    wrapper.classList.toggle('is-error', Boolean(message));
    const node = wrapper.querySelector('[data-role="field-error"]');
    if (node) node.textContent = message;
  }

  function clearErrors(ctx) {
    Object.keys(ctx.wrappers).forEach((name) => setFieldError(ctx, name, ''));
    if (ctx.formErrors) {
      ctx.formErrors.classList.remove('is-active');
      ctx.formErrors.textContent = '';
    }
  }

  function setFormError(ctx, message) {
    if (!ctx.formErrors) return;
    ctx.formErrors.textContent = message || '';
    ctx.formErrors.classList.toggle('is-active', Boolean(message));
  }

  function selectedInputs(ctx) {
    return {
      budget: toNumber(ctx.fields.budget?.value),
      currency: ctx.fields.currency?.value || 'TRY',
      country: ctx.fields.country?.value || null,
      program: ctx.fields.program?.value || null,
      region: ctx.fields.region?.value || null,
      housingEnabled: Boolean(ctx.fields.housingEnabled?.checked),
      housingType: ctx.fields.housingType?.value || 'shared_room'
    };
  }

  function toggleRegion(ctx) {
    const country = SimulatorData.country(ctx.config, ctx.fields.country?.value);
    const required = Boolean(country?.requires_region);

    if (required) {
      const regions = (country.regions || []).filter((item) => item.launch_enabled);
      populateSelect(ctx.fields.region, regions, 'Bölge seç', 'region_code', 'region_name_tr');
      ctx.fields.region?.removeAttribute('disabled');
      ctx.regionRow?.classList.add('is-active');
      ctx.regionRow?.setAttribute('aria-hidden', 'false');
    } else {
      if (ctx.fields.region) {
        ctx.fields.region.value = '';
        ctx.fields.region.setAttribute('disabled', 'disabled');
      }
      ctx.regionRow?.classList.remove('is-active');
      ctx.regionRow?.setAttribute('aria-hidden', 'true');
      setFieldError(ctx, 'region', '');
    }
  }

  function toggleHousing(ctx) {
    if (!ctx.fields.housingType) return;
    const enabled = Boolean(ctx.fields.housingEnabled?.checked);
    ctx.fields.housingType.disabled = !enabled;
    if (!enabled) ctx.fields.housingType.value = 'shared_room';
  }

  function syncSubmit(ctx) {
    const inputs = selectedInputs(ctx);
    const country = SimulatorData.country(ctx.config, inputs.country);
    const ready = (
      inputs.budget > 0 &&
      Boolean(inputs.currency) &&
      Boolean(inputs.country) &&
      Boolean(inputs.program) &&
      (!country?.requires_region || Boolean(inputs.region))
    );

    if (ctx.fields.submit) ctx.fields.submit.disabled = !ready;
  }

  function validate(ctx) {
    clearErrors(ctx);
    const inputs = selectedInputs(ctx);
    const country = SimulatorData.country(ctx.config, inputs.country);
    let valid = true;

    if (inputs.budget <= 0) {
      setFieldError(ctx, 'budget', 'Lütfen sıfırdan büyük bir haftalık bütçe gir.');
      valid = false;
    }
    if (!inputs.country) {
      setFieldError(ctx, 'country', 'Lütfen bir ülke seç.');
      valid = false;
    }
    if (!inputs.program) {
      setFieldError(ctx, 'program', 'Lütfen bir program türü seç.');
      valid = false;
    }
    if (country?.requires_region && !inputs.region) {
      setFieldError(ctx, 'region', 'Bu ülke için bölge seçimi gerekiyor.');
      valid = false;
    }

    if (!valid) setFormError(ctx, 'Eksik alanları kontrol ederek yeniden dene.');
    return valid;
  }

  function normalizeHousingWeekly(entry) {
    if (!entry) return 0;
    const amount = toNumber(entry.amount_local);

    switch (entry.billing_cycle) {
      case 'week':
        return amount;
      case 'month':
        return amount / AVG_WEEKS_PER_MONTH;
      case 'year':
        return amount / 52;
      case 'semester':
        return amount / (toNumber(entry.contract_weeks) || 19.5);
      case 'contract':
        return amount / (toNumber(entry.contract_weeks) || 1);
      default:
        return amount;
    }
  }

  function componentTotal(basket) {
    return (basket?.living_components || []).reduce(
      (sum, item) => sum + toNumber(item.amount_local),
      0
    );
  }

  function calculate(ctx, inputs) {
    const basket = SimulatorData.basket(ctx.config, inputs.country, inputs.region);
    const rule = SimulatorData.rule(ctx.config, inputs.country, inputs.program, inputs.region);

    if (!basket || basket.source_verification_needed) {
      return {
        ok: false,
        title: 'Bu rota için doğrulanmış gider verisi hazır değil',
        text: 'Farklı bir seçim yapabilir veya bütçeni danışmanla birlikte değerlendirebilirsin.'
      };
    }

    let housing = null;
    let housingWeeklyLocal = 0;

    if (inputs.housingEnabled) {
      housing = SimulatorData.housing(
        ctx.config,
        inputs.country,
        inputs.region,
        inputs.housingType
      );

      if (!housing || housing.source_verification_needed) {
        return {
          ok: false,
          title: 'Konaklama verisi henüz hazır değil',
          text: 'Bu konaklama türü için doğrulanmış temsilî değer bulunamadı.'
        };
      }

      housingWeeklyLocal = normalizeHousingWeekly(housing);
    }

    const localCurrency = basket.currency;
    const componentsTotal = componentTotal(basket);
    const declaredTotal = toNumber(basket.basket_total_local);
    const basketWeeklyLocal = componentsTotal > 0 ? componentsTotal : declaredTotal;
    const dataMismatch = Math.abs(componentsTotal - declaredTotal) > 0.01;
    const totalWeeklyLocal = basketWeeklyLocal + housingWeeklyLocal;

    const budgetWeeklyLocal = SimulatorData.convert(
      ctx,
      inputs.budget,
      inputs.currency,
      localCurrency
    );

    const totalWeeklyDisplay = SimulatorData.convert(
      ctx,
      totalWeeklyLocal,
      localCurrency,
      inputs.currency
    );

    const coveragePercent = (
      Number.isFinite(budgetWeeklyLocal) && totalWeeklyLocal > 0
        ? (budgetWeeklyLocal / totalWeeklyLocal) * 100
        : 0
    );

    const hours = toNumber(rule?.work_hours_term_week);
    const wage = toNumber(rule?.minimum_wage_hourly);
    const wageCurrency = rule?.minimum_wage_currency || localCurrency;
    const theoreticalIncomeDisplay = (
      hours > 0 && wage > 0
        ? SimulatorData.convert(ctx, hours * wage, wageCurrency, inputs.currency)
        : 0
    );

    const verifiedDate = latestDate([
      basket.price_source_date,
      housing?.price_source_date,
      rule?.legal_last_checked
    ]);

    const pricingStaleAfter = toNumber(
      ctx.config?.data_freshness_policy?.pricing_stale_after_days
    ) || 120;
    const legalStaleAfter = toNumber(
      ctx.config?.data_freshness_policy?.legal_stale_after_days
    ) || 90;

    return {
      ok: true,
      inputs,
      basket,
      housing,
      rule,
      localCurrency,
      displayCurrency: inputs.currency,
      basketWeeklyLocal,
      housingWeeklyLocal,
      totalWeeklyLocal,
      totalWeeklyDisplay,
      coveragePercent,
      hours,
      wage,
      wageCurrency,
      theoreticalIncomeDisplay,
      verifiedDate,
      pricingStale: daysSince(
        latestDate([basket.price_source_date, housing?.price_source_date])
      ) > pricingStaleAfter,
      legalStale: daysSince(rule?.legal_last_checked) > legalStaleAfter,
      dataMismatch
    };
  }

  function setBadge(node, tone, label) {
    if (!node) return;
    node.className = `simulator-badge simulator-badge--${tone}`;
    node.textContent = label;
  }

  function setStatus(ctx, title, text, active = true) {
    ctx.results.statusBlock?.classList.toggle('is-active', active);
    if (ctx.results.statusTitle) ctx.results.statusTitle.textContent = title || '';
    if (ctx.results.statusText) ctx.results.statusText.textContent = text || '';
  }

  function setCardClass(card, prefix, target) {
    if (!card) return;
    [...card.classList].forEach((className) => {
      if (className.startsWith(`${prefix}--`)) card.classList.remove(className);
    });
    if (target) card.classList.add(target);
  }

  function buildBreakdown(result) {
    const rows = (result.basket.living_components || []).map((component) => `
      <div class="simulator-living-breakdown__row">
        <span class="simulator-living-breakdown__label">
          ${escapeHtml(COMPONENT_LABELS[component.component_code] || component.component_code)}
        </span>
        <strong class="simulator-living-breakdown__value">
          ${escapeHtml(formatCurrency(toNumber(component.amount_local), result.localCurrency, 0))}
        </strong>
      </div>
    `);

    if (result.inputs.housingEnabled && result.housingWeeklyLocal > 0) {
      const housingLabels = {
        shared_room: 'Konaklama — paylaşımlı oda',
        residence_standard: 'Konaklama — öğrenci yurdu',
        studio_private: 'Konaklama — stüdyo / özel alan'
      };

      rows.push(`
        <div class="simulator-living-breakdown__row simulator-living-breakdown__row--housing">
          <span class="simulator-living-breakdown__label">
            ${escapeHtml(housingLabels[result.inputs.housingType] || 'Konaklama')}
          </span>
          <strong class="simulator-living-breakdown__value">
            ${escapeHtml(formatCurrency(result.housingWeeklyLocal, result.localCurrency, 0))}
          </strong>
        </div>
      `);
    }

    return rows.join('');
  }

  function renderMarket(ctx, result) {
    const displayValue = result.totalWeeklyDisplay;

    if (ctx.results.marketValue) {
      ctx.results.marketValue.textContent = Number.isFinite(displayValue)
        ? formatNumber(displayValue, 0)
        : '—';
    }
    if (ctx.results.marketCurrency) {
      ctx.results.marketCurrency.textContent = result.displayCurrency;
    }
    if (ctx.results.marketSubvalue) {
      ctx.results.marketSubvalue.textContent = result.inputs.housingEnabled
        ? 'Konaklama dahil temsilî haftalık toplam'
        : 'Konaklama hariç temsilî haftalık toplam';
    }
    if (ctx.results.marketIntro) {
      ctx.results.marketIntro.textContent = (
        `Hedef ülkedeki ${result.inputs.housingEnabled ? 'yaşam ve konaklama' : 'temel yaşam'} `
        + 'giderleri, seçtiğin bütçe para biriminde gösteriliyor.'
      );
    }
    if (ctx.results.livingBreakdown) {
      ctx.results.livingBreakdown.innerHTML = buildBreakdown(result);
    }

    const roundedCoverage = Math.max(0, Math.round(result.coveragePercent));
    const progressValue = clamp(roundedCoverage, 0, 100);

    if (ctx.results.coverageLabel) {
      ctx.results.coverageLabel.textContent = `%${roundedCoverage}`;
    }
    if (ctx.results.coverageFill) {
      ctx.results.coverageFill.style.width = `${progressValue}%`;
    }
    if (ctx.results.coverageMeter) {
      ctx.results.coverageMeter.setAttribute('aria-valuenow', String(progressValue));
    }
    if (ctx.results.coverageNote) {
      ctx.results.coverageNote.textContent = (
        result.coveragePercent >= 100
          ? `Girdiğin bütçe, temsilî haftalık toplamın yaklaşık %${roundedCoverage} karşılığına ulaşıyor.`
          : `Girdiğin bütçe, temsilî haftalık toplamın yaklaşık %${roundedCoverage} kadarını karşılıyor.`
      );
    }
    if (ctx.results.basketNote) {
      ctx.results.basketNote.textContent = result.basket.average_price_note || '';
    }
    if (ctx.results.housingNote) {
      ctx.results.housingNote.textContent = result.inputs.housingEnabled
        ? (result.housing?.housing_scope_note || 'Temsilî konaklama gideri eklendi.')
        : 'Konaklama bu hesaplamaya dahil edilmedi.';
    }
    if (ctx.results.marketSourceNote) {
      const mismatchNote = result.dataMismatch
        ? 'Not: Veri tablosundaki toplam ile bileşenler farklı olduğu için bileşenlerin toplamı kullanıldı.'
        : '';
      ctx.results.marketSourceNote.textContent = [
        result.basket.basket_scope_note,
        result.housing?.price_source_name,
        mismatchNote
      ].filter(Boolean).join(' · ');
    }

    if (ctx.results.marketStaleWarning) {
      ctx.results.marketStaleWarning.hidden = !result.pricingStale;
      ctx.results.marketStaleWarning.classList.toggle('is-active', result.pricingStale);
    }

    setCardClass(ctx.results.marketCard, 'card-market', 'card-market--ready');
  }

  function renderWork(ctx, result) {
    const status = result.rule?.work_rights_status || 'route_dependent';
    const meta = WORK_META[status] || WORK_META.route_dependent;
    const stale = result.legalStale;

    setBadge(
      ctx.results.workBadge,
      stale ? 'warning' : meta.tone,
      stale ? 'Güncellik kontrolü gerekli' : meta.label
    );

    if (ctx.results.workText) {
      ctx.results.workText.textContent = result.rule?.note_short
        || 'Bu rota için çalışma koşulları ayrıca doğrulanmalıdır.';
    }

    if (ctx.results.workMeta) {
      ctx.results.workMeta.textContent = (
        result.hours > 0
          ? `Dönem içinde yaklaşık ${result.hours} saat / hafta sınırı`
          : 'Güvenli bir saat varsayımı gösterilmiyor'
      );
    }

    if (ctx.results.workDate) {
      ctx.results.workDate.textContent = formatDateTR(result.rule?.legal_last_checked);
    }

    if (ctx.results.workSourceLink) {
      const url = result.rule?.legal_source_url;
      ctx.results.workSourceLink.classList.toggle('is-hidden', !url);
      if (url) ctx.results.workSourceLink.href = url;
    }

    if (ctx.results.workStaleWarning) {
      ctx.results.workStaleWarning.hidden = !stale;
      ctx.results.workStaleWarning.classList.toggle('is-active', stale);
    }

    setCardClass(
      ctx.results.workCard,
      'card-work',
      stale ? 'card-work--route-dependent' : meta.cardClass
    );
  }

  function renderIncome(ctx, result) {
    const status = result.rule?.work_rights_status || 'route_dependent';
    const numericAllowed = (
      !result.legalStale &&
      (status === 'available' || status === 'restricted') &&
      result.theoreticalIncomeDisplay > 0
    );

    if (numericAllowed) {
      setBadge(
        ctx.results.incomeBadge,
        status === 'available' ? 'success' : 'warning',
        status === 'available' ? 'Teorik senaryo açık' : 'Temkinli senaryo'
      );
      if (ctx.results.incomeValue) {
        ctx.results.incomeValue.textContent = formatNumber(
          result.theoreticalIncomeDisplay,
          0
        );
      }
      if (ctx.results.incomeCurrency) {
        ctx.results.incomeCurrency.textContent = result.displayCurrency;
      }
      if (ctx.results.incomeText) {
        ctx.results.incomeText.textContent = (
          'Bu değer teorik haftalık brüt gelir görünümüdür; gerçek kazanç değildir.'
        );
      }
      if (ctx.results.incomeMeta) {
        ctx.results.incomeMeta.textContent = (
          `${result.hours} saat × ${formatCurrency(result.wage, result.wageCurrency, 2)}`
        );
      }
      setCardClass(
        ctx.results.incomeCard,
        'card-income',
        status === 'available' ? 'card-income--full' : 'card-income--limited'
      );
      return;
    }

    setBadge(
      ctx.results.incomeBadge,
      result.legalStale ? 'warning' : 'info',
      result.legalStale ? 'Güncellik kontrolü gerekli' : 'Sayısal tahmin kapalı'
    );
    if (ctx.results.incomeValue) ctx.results.incomeValue.textContent = '—';
    if (ctx.results.incomeCurrency) ctx.results.incomeCurrency.textContent = '';
    if (ctx.results.incomeText) {
      ctx.results.incomeText.textContent = result.legalStale
        ? 'Resmî çalışma ve ücret verisi yeniden kontrol edilmeden gelir tahmini gösterilmiyor.'
        : 'Bu rota için çalışma hakkı veya saat sınırı yeterince net olmadığı için gelir hesaplanmıyor.';
    }
    if (ctx.results.incomeMeta) {
      ctx.results.incomeMeta.textContent = 'Bütçe planını çalışma gelirine bağlı kurma.';
    }
    setCardClass(ctx.results.incomeCard, 'card-income', 'card-income--route-dependent');
  }

  function renderLinks(ctx, inputs) {
    if (!ctx.links.list) return;

    const links = (ctx.config.internal_links || []).filter((item) => {
      if (!item.enabled) return false;
      const countryOk = !item.country_code || item.country_code === inputs.country;
      const regionOk = !item.region_code || item.region_code === inputs.region;
      const programOk = !item.program_type || item.program_type === inputs.program;
      return countryOk && regionOk && programOk;
    });

    ctx.links.list.innerHTML = links.map((item) => `
      <li class="simulator-links__item">
        <a class="simulator-links__link" href="${escapeHtml(item.url)}">
          <span>${escapeHtml(item.label)}</span>
          <span aria-hidden="true">↗</span>
        </a>
      </li>
    `).join('');

    ctx.links.empty?.classList.toggle('is-hidden', links.length > 0);

    const countryGuide = links.find((item) => item.link_type === 'country_guide');
    if (ctx.secondaryCta && countryGuide) {
      ctx.secondaryCta.href = countryGuide.url;
      ctx.secondaryCta.textContent = countryGuide.label;
      ctx.secondaryCta.classList.remove('is-hidden');
    }
  }

  function renderDates(ctx, verifiedDate) {
    const fxDate = ctx.fx?.rateDate || null;

    if (ctx.results.verifiedDateLabel) {
      ctx.results.verifiedDateLabel.textContent = `Veri kontrolü: ${formatDateTR(verifiedDate)}`;
    }
    if (ctx.results.fxDateLabel) {
      ctx.results.fxDateLabel.textContent = `Kur tarihi: ${formatDateTR(fxDate)}`;
    }
    if (ctx.globalDate) ctx.globalDate.textContent = formatDateTR(verifiedDate);
    if (ctx.globalFxDate) ctx.globalFxDate.textContent = formatDateTR(fxDate);
  }

  function renderSuccess(ctx, result) {
    setStatus(ctx, '', '', false);
    ctx.root.classList.add('has-results');

    const country = SimulatorData.country(ctx.config, result.inputs.country);
    const program = SimulatorData.programs(ctx.config).find(
      (item) => item.program_type === result.inputs.program
    );

    if (ctx.results.routeSummary) {
      ctx.results.routeSummary.textContent = [
        country?.country_name_tr,
        result.inputs.region,
        program?.program_name_tr
      ].filter(Boolean).join(' · ');
    }

    renderDates(ctx, result.verifiedDate);
    renderMarket(ctx, result);
    renderWork(ctx, result);
    renderIncome(ctx, result);
    renderLinks(ctx, result.inputs);

    ctx.results.statusBlock?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
      block: 'nearest'
    });
  }

  function renderFailure(ctx, failure) {
    setStatus(ctx, failure.title, failure.text, true);
    ctx.root.classList.remove('has-results');
  }

  function resetResults(ctx) {
    setStatus(
      ctx,
      'Seçimlerini tamamla',
      'Bütçe, ülke ve program seçimi yapıldığında sonuç kartları güncellenecek.',
      true
    );

    if (ctx.results.routeSummary) {
      ctx.results.routeSummary.textContent = 'Rota seçimi bekleniyor';
    }

    renderDates(ctx, null);
    setBadge(ctx.results.workBadge, 'neutral', 'Seçim bekleniyor');
    setBadge(ctx.results.incomeBadge, 'neutral', 'Hesaplama bekleniyor');

    if (ctx.results.marketValue) ctx.results.marketValue.textContent = '—';
    if (ctx.results.marketCurrency) ctx.results.marketCurrency.textContent = '';
    if (ctx.results.marketSubvalue) ctx.results.marketSubvalue.textContent = 'Önce hesaplama yap.';
    if (ctx.results.marketIntro) {
      ctx.results.marketIntro.textContent = 'Seçtiğin rota için temsilî haftalık yaşam gideri burada görünür.';
    }
    if (ctx.results.livingBreakdown) {
      ctx.results.livingBreakdown.innerHTML = `
        <div class="simulator-living-breakdown__row">
          <span class="simulator-living-breakdown__label">Hesaplama bekleniyor</span>
          <span class="simulator-living-breakdown__value">—</span>
        </div>
      `;
    }
    if (ctx.results.coverageLabel) ctx.results.coverageLabel.textContent = '—';
    if (ctx.results.coverageFill) ctx.results.coverageFill.style.width = '0%';
    if (ctx.results.coverageMeter) ctx.results.coverageMeter.setAttribute('aria-valuenow', '0');
    if (ctx.results.basketNote) ctx.results.basketNote.textContent = '';
    if (ctx.results.housingNote) ctx.results.housingNote.textContent = '';
    if (ctx.results.coverageNote) ctx.results.coverageNote.textContent = '';
    if (ctx.results.marketSourceNote) ctx.results.marketSourceNote.textContent = '';
    if (ctx.results.workText) ctx.results.workText.textContent = 'Önce ülke ve program seç.';
    if (ctx.results.workMeta) ctx.results.workMeta.textContent = '—';
    if (ctx.results.workDate) ctx.results.workDate.textContent = '—';
    if (ctx.results.incomeValue) ctx.results.incomeValue.textContent = '—';
    if (ctx.results.incomeCurrency) ctx.results.incomeCurrency.textContent = '';
    if (ctx.results.incomeText) ctx.results.incomeText.textContent = 'Önce hesaplama yap.';
    if (ctx.results.incomeMeta) ctx.results.incomeMeta.textContent = '—';

    ctx.results.marketStaleWarning?.setAttribute('hidden', '');
    ctx.results.workStaleWarning?.setAttribute('hidden', '');
    ctx.results.workSourceLink?.classList.add('is-hidden');

    setCardClass(ctx.results.marketCard, 'card-market', 'card-market--estimate');
    setCardClass(ctx.results.workCard, 'card-work', 'card-work--empty');
    setCardClass(ctx.results.incomeCard, 'card-income', 'card-income--hidden');

    renderLinks(ctx, selectedInputs(ctx));
  }

  function fxStatus(ctx) {
    const staleAfter = toNumber(ctx.config?.fx_config?.fallback_policy?.stale_after_days) || 5;
    const stale = daysSince(ctx.fx?.rateDate) > staleAfter;

    if (ctx.fx?.mode === 'live' && !stale) {
      return {
        className: 'away-fx__status--live',
        label: 'ECB referans verisi',
        globalLabel: 'Canlı ECB referansı'
      };
    }

    if (stale) {
      return {
        className: 'away-fx__status--stale',
        label: 'Tarihli yedek kur',
        globalLabel: 'Yedek kur — güncellik kontrolü gerekli'
      };
    }

    return {
      className: 'away-fx__status--fallback',
      label: 'Yedek referans kur',
      globalLabel: 'Yedek referans kur'
    };
  }

  function renderFx(ctx) {
    if (!ctx.fxNodes.panel || !ctx.fx) return;

    const inputs = selectedInputs(ctx);
    const country = SimulatorData.country(ctx.config, inputs.country)
      || SimulatorData.country(ctx.config, ctx.defaults.country);
    const localCurrency = country?.default_currency || 'EUR';
    const budgetCurrency = inputs.currency || 'TRY';
    const pairValue = SimulatorData.convert(ctx, 1, localCurrency, budgetCurrency);
    const budgetConverted = inputs.budget > 0
      ? SimulatorData.convert(ctx, inputs.budget, budgetCurrency, localCurrency)
      : Number.NaN;

    const status = fxStatus(ctx);
    if (ctx.fxNodes.status) {
      ctx.fxNodes.status.className = `away-fx__status ${status.className}`;
      ctx.fxNodes.status.innerHTML = `
        <span class="away-fx__status-dot" aria-hidden="true"></span>
        ${escapeHtml(status.label)}
      `;
    }
    if (ctx.fxNodes.date) {
      ctx.fxNodes.date.textContent = `Kur tarihi: ${formatDateTR(ctx.fx.rateDate)}`;
    }
    if (ctx.fxNodes.pairLabel) {
      ctx.fxNodes.pairLabel.textContent = country
        ? `${country.country_name_tr} için ana kur`
        : 'Seçilen para birimi çifti';
    }
    if (ctx.fxNodes.pairValue) {
      ctx.fxNodes.pairValue.textContent = localCurrency === budgetCurrency
        ? `${localCurrency} ve ${budgetCurrency} aynı para birimi`
        : `1 ${localCurrency} ≈ ${formatNumber(pairValue, 4)} ${budgetCurrency}`;
    }
    if (ctx.fxNodes.budgetConversion) {
      ctx.fxNodes.budgetConversion.textContent = Number.isFinite(budgetConverted)
        ? `${formatCurrency(inputs.budget, budgetCurrency, 0)} haftalık bütçe ≈ `
          + `${formatCurrency(budgetConverted, localCurrency, 0)}`
        : 'Haftalık bütçeni girdiğinde hedef ülke para birimindeki karşılığını burada göreceksin.';
    }
    if (ctx.fxNodes.sourceName) {
      ctx.fxNodes.sourceName.textContent = ctx.fx.sourceName || 'Avrupa Merkez Bankası';
    }
    if (ctx.fxNodes.sourceNote) {
      ctx.fxNodes.sourceNote.textContent = (
        ctx.config?.fx_config?.reference_rate_note_tr
        || 'Referans kur, gerçek işlem kurundan farklı olabilir.'
      );
    }
    if (ctx.fxNodes.sourceLink) {
      ctx.fxNodes.sourceLink.href = (
        ctx.config?.fx_config?.live_source?.source_page
        || 'https://data.ecb.europa.eu/'
      );
    }

    const currencies = ctx.config?.fx_config?.display_currencies
      || ['EUR', 'GBP', 'USD', 'CAD', 'AUD'];
    const quoteCurrency = ctx.config?.fx_config?.display_quote_currency || 'TRY';

    if (ctx.fxNodes.rates) {
      ctx.fxNodes.rates.innerHTML = currencies.map((currency) => {
        const value = SimulatorData.convert(ctx, 1, currency, quoteCurrency);
        const selected = currency === localCurrency ? ' is-selected' : '';

        return `
          <article class="away-fx__rate-card${selected}">
            <div class="away-fx__rate-top">
              <span class="away-fx__currency-code">${escapeHtml(currency)}</span>
              ${currency === localCurrency ? '<span class="away-fx__selected-label">Hedef ülke</span>' : ''}
            </div>
            <strong class="away-fx__rate-value">
              ${escapeHtml(formatNumber(value, 4))}
            </strong>
            <span class="away-fx__rate-unit">
              1 ${escapeHtml(currency)} ≈ ${escapeHtml(quoteCurrency)}
            </span>
            <span class="away-fx__currency-name">
              ${escapeHtml(CURRENCY_NAMES[currency] || currency)}
            </span>
          </article>
        `;
      }).join('');
    }

    if (ctx.globalFxStatus) ctx.globalFxStatus.textContent = status.globalLabel;
    if (ctx.globalFxDate) ctx.globalFxDate.textContent = formatDateTR(ctx.fx.rateDate);
  }

  async function refreshFx(ctx) {
    if (!ctx.fxNodes.refresh) return;

    ctx.fxNodes.refresh.disabled = true;
    ctx.fxNodes.refresh.textContent = 'Yenileniyor…';

    try {
      ctx.fx = await loadFx(ctx.config, true);
      renderFx(ctx);
      resetResults(ctx);
    } finally {
      ctx.fxNodes.refresh.disabled = false;
      ctx.fxNodes.refresh.textContent = 'Kurları yenile';
    }
  }

  function bindEvents(ctx) {
    ctx.fields.country?.addEventListener('change', () => {
      toggleRegion(ctx);
      syncSubmit(ctx);
      renderFx(ctx);
      resetResults(ctx);
    });

    ctx.fields.program?.addEventListener('change', () => {
      syncSubmit(ctx);
      resetResults(ctx);
    });

    ctx.fields.region?.addEventListener('change', () => {
      syncSubmit(ctx);
      resetResults(ctx);
    });

    ctx.fields.budget?.addEventListener('input', () => {
      setFieldError(ctx, 'budget', '');
      syncSubmit(ctx);
      renderFx(ctx);
    });

    ctx.fields.currency?.addEventListener('change', () => {
      syncSubmit(ctx);
      renderFx(ctx);
      resetResults(ctx);
    });

    ctx.fields.housingEnabled?.addEventListener('change', () => {
      toggleHousing(ctx);
      resetResults(ctx);
    });

    ctx.fields.housingType?.addEventListener('change', () => resetResults(ctx));

    ctx.fxNodes.refresh?.addEventListener('click', () => refreshFx(ctx));

    ctx.form?.addEventListener('submit', (event) => {
  event.preventDefault();

  if (!validate(ctx)) return;

  try {
    const result = calculate(ctx, selectedInputs(ctx));

    if (result.ok) {
      renderSuccess(ctx, result);
    } else {
      renderFailure(ctx, result);
    }
  } catch (error) {
    console.error('[AwaySimulator] Hesaplama hatası:', error);

    renderFailure(ctx, {
      title: 'Sonuç oluşturulamadı',
      text: 'Beklenmeyen bir hesaplama hatası oluştu. Sayfayı yenileyip tekrar deneyin.'
    });
  }
});
  }

  function applyDefaults(ctx) {
    const countries = SimulatorData.countries(ctx.config);
    const programs = SimulatorData.programs(ctx.config);

    populateSelect(
      ctx.fields.country,
      countries,
      'Ülke seç',
      'country_code',
      'country_name_tr'
    );

    populateSelect(
      ctx.fields.program,
      programs,
      'Program seç',
      'program_type',
      'program_name_tr'
    );

    if (countries.some((item) => item.country_code === ctx.defaults.country)) {
      ctx.fields.country.value = ctx.defaults.country;
    }
    if (programs.some((item) => item.program_type === ctx.defaults.program)) {
      ctx.fields.program.value = ctx.defaults.program;
    }

    toggleRegion(ctx);
    toggleHousing(ctx);
    syncSubmit(ctx);
  }

  function showInitError(root, message) {
    const statusBlock = root.querySelector('[data-role="status-block"]');
    const statusTitle = root.querySelector('[data-role="status-title"]');
    const statusText = root.querySelector('[data-role="status-text"]');

    statusBlock?.classList.add('is-active');
    if (statusTitle) statusTitle.textContent = 'Simülatör yüklenemedi';
    if (statusText) statusText.textContent = message;
  }

  async function initOne(root) {
    if (!root || root.dataset.simulatorInitialized === 'true') return;
    root.dataset.simulatorInitialized = 'true';

    const config = await loadConfig(root);
    if (!config) {
      showInitError(root, 'Veri dosyası yüklenemedi. Asset bağlantısını kontrol et.');
      return;
    }

    const fxData = await loadFx(config);
    const ctx = createContext(root, config, fxData);

    if (!ctx.form) {
      showInitError(root, 'Simülatör formu bulunamadı.');
      return;
    }

    applyDefaults(ctx);
    renderFx(ctx);
    resetResults(ctx);
    bindEvents(ctx);
  }

  function initWithin(scope = document) {
    const roots = scope.matches?.(ROOT_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(ROOT_SELECTOR) || []);

    roots.forEach((root) => initOne(root));
  }

  window.__awayBudgetSimulatorV13InitWithin = initWithin;

  const boot = () => initWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:select', (event) => initWithin(event.target));
})();